"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var escape_element_1 = require("./escape-element");
/**
 * Represents an XML text value.
 */
var XmlText = /** @class */ (function () {
    function XmlText(value) {
        this.value = value;
    }
    XmlText.prototype.toString = function () {
        return escape_element_1.escapeElement("" + this.value);
    };
    return XmlText;
}());
exports.XmlText = XmlText;
//# sourceMappingURL=XmlText.js.map